import { Outlet, createFileRoute } from '@tanstack/react-router';

// Shell route — lets /app/approvals (index) and child routes like
// /app/approvals/:batchId/preview live under the same path segment.
// File-based routes only render a child route's component when the
// parent renders <Outlet/>, otherwise the parent's component absorbs
// every URL under it.
function ApprovalsLayout() {
  return <Outlet />;
}

export const Route = createFileRoute('/app/approvals')({
  component: ApprovalsLayout,
});
